


export enum SegmentsEnum {
	head = 'Oblast hlavy',
	chest = 'Oblast krku',
	belly = 'Břicho',
	back = 'Hřbet',
	rump = 'Záď',
	tail = 'Ocas',
	upperThigh = 'Slabiny a pohlavní orgány',
	lowerThigh = 'Oblast kolene a bérce',
	hock = 'Zadní nárt',
	hindpaw = 'Zadní tlapky',
	forearm = 'Loket a předloktí',
	wrist = 'Oblast zápěstí',
	forepaw = 'Přední tlapky',
}